// Wybór rodziny, gdy użytkownik ma więcej niż jedno członkostwo.
//
// Zdarza się, gdy ktoś założy konto przed użyciem linku z zaproszenia: auth-hook
// zakłada mu wtedy własną pustą rodzinę, a akceptacja zaproszenia dopisuje drugie
// członkostwo. Wcześniej `.single()` zwracało przy dwóch wierszach błąd PGRST116
// i aplikacja pokazywała „nie należysz do żadnej rodziny”.
//
// To wyłącznie wybór, którą z WŁASNYCH rodzin pokazać — dostęp do danych
// i tak rozstrzyga RLS na podstawie wierszy family_members.

export interface MembershipCandidate {
  family_id: string
  /** Liczba innych członków tej rodziny (bez samego użytkownika). */
  otherMembers: number
  children: number
  joined_at: string | null
}

// Kolejność: rodzina z drugą osobą > rodzina z dziećmi > pusta; remis → najpóźniej dołączona.
export function pickPrimaryFamilyId(candidates: MembershipCandidate[]): string | null {
  if (candidates.length === 0) return null

  const score = (c: MembershipCandidate) => (c.otherMembers > 0 ? 2 : 0) + (c.children > 0 ? 1 : 0)
  const joinedTs = (c: MembershipCandidate) => {
    const t = c.joined_at ? new Date(c.joined_at).getTime() : NaN
    return Number.isFinite(t) ? t : -Infinity
  }

  const sorted = [...candidates].sort((a, b) =>
    score(b) - score(a) ||
    joinedTs(b) - joinedTs(a) ||
    a.family_id.localeCompare(b.family_id)
  )
  return sorted[0].family_id
}
